<template>
  <v-app>
    <v-card
      width="95%"
      class="mx-auto mt-5"
    >
      <LocaleSwitcher />
      <v-card-title>
        {{ $t("sginIn.ログイン") }}
      </v-card-title>
      <v-form>
        <div class="signin ma-5">
          <v-text-field
            id="email"
            v-model="name"
            prepend-icon="mdi-account-circle"
            :label="$t('sginIn.メールアドレス')"
          />
          <v-text-field
            id="password"
            v-model="password"
            :type="showPassword ? 'text' : 'password'"
            prepend-icon="mdi-lock"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :label="$t('sginIn.パスワード')"
            @click:append="showPassword = !showPassword"
          />
          <v-alert
            v-model="alert"
            close-text="Close Alert"
            color="red accent-4"
            dark
            dismissible
            class="ma-5"
          >
            {{ error_message }}
          </v-alert>
          <v-btn
            id="submit"
            class="info"
            @click="doLogin"
          >
            {{ $t("sginIn.ログイン") }}
          </v-btn>
        </div>
      </v-form>
    </v-card>

    <v-card
      v-if="clinic_id"
      width="95%"
      class="mx-auto mt-5"
    >
      <v-card-text>
        {{ $t("sginIn.初めてお使いになるお客様へ") }}<br>
        {{ $t("sginIn.新しいアカウントを作成しますか？") }}<br>
        <v-btn
          id="singup"
          :to="`/signup/${clinic_id}`"
          @click="doLogin"
        >
          {{ $t("sginIn.新規登録") }}
        </v-btn>
      </v-card-text>
    </v-card>

    <v-card
      width="95%"
      class="mx-auto mt-5"
    >
      <v-card-text>
        {{ $t("sginIn.パスワードがわからない場合") }}
        <v-expansion-panels class="mt-5">
          <v-expansion-panel>
            <v-expansion-panel-header>
              {{ $t("sginIn.パスワード再設定") }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-text-field
                id="reset_email"
                v-model="email"
                prepend-icon="mdi-account-circle"
                :label="$t('sginIn.メールアドレス')"
              />
              <v-alert
                v-model="reset_alert"
                close-text="Close Alert"
                color="orange accent-4"
                dark
                dismissible
                class="ma-5"
              >
                {{ reset_alert_message }}
              </v-alert>
              <v-btn
                id="submit_reset"
                class="success"
                @click="reset_password"
              >
                {{ $t("sginIn.再設定メール送信") }}
              </v-btn>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>
    </v-card>
  </v-app>
</template>

<script>
import { Firebase } from "../config/firebase";
import firebase from "firebase/app";
import "firebase/auth";
import LocaleSwitcher from "@/components/LocaleSwitcher";

export default {
  name: "Login",
  components: { LocaleSwitcher },
  data() {
    return {
      showPassword: false,
      error_message: "",
      alert: false,
      name: "",
      password: "",
      email: "",
      reset_alert: false,
      reset_alert_message: "",
      user: null,
      clinics: [],
    };
  },
  computed: {
    clinic_id() {
      return this.$route.params.id;
    },
  },
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        console.log("User is logged in:", user);
      } else {
        console.log("No user is logged in");
      }
    });
  },
  methods: {
    async reset_password() {
      const actionCodeSettings = {
        url: "https://clinic-customer.web.app/login",
        handleCodeInApp: false,
      };

      try {
        await firebase
          .auth()
          .sendPasswordResetEmail(this.email, actionCodeSettings);
        this.reset_alert = true;
        this.reset_alert_message =
          "ご登録のメールアドレスに再設定のリンクを送付いたしました。";
      } catch (err) {
        this.reset_alert = true;
        this.reset_alert_message =
          "ご登録のアドレスがございません。メールアドレスのご確認をお願いします。";
        console.error(err);
      }
    },

    async doLogin() {
      if (!this.name) {
        this.error_message =
          "ログインできません。メールアドレスを入力してください。";
        this.alert = true;
        return;
      }

      if (!this.password) {
        this.error_message =
          "ログインできません。パスワードを入力してください。";
        this.alert = true;
        return;
      }

      try {
        const userCredential = await firebase
          .auth()
          .signInWithEmailAndPassword(this.name, this.password);
        console.log("User logged in:", userCredential.user);
      } catch (error) {
        console.error("Login error:", error.message);
        this.error_message =
          "ログインに失敗しました。メールアドレスまたはパスワードが正しくありません。";
        this.alert = true;
        return;
      }

      if (this.clinic_id) {
        try {
          const userRef = Firebase.firestore()
            .collection("Users")
            .doc(this.$store.getters.user.uid);

          const doc = await userRef.get();
          if (doc.exists) {
            this.user = doc.data();
            this.user.id = doc.id;
            this.clinics = this.user.clinics;
          } else {
            console.log("No user document!");
          }

          const is_registered = this.clinics.some(
            (clinic) => clinic.clinic_id === this.clinic_id
          );

          if (is_registered) {
            this.$router.push({
              name: "priscription_list",
              params: { id: this.clinic_id },
            });
          } else {
            this.$router.push({
              name: "patient_regster",
              params: { id: this.clinic_id },
            });
          }
        } catch (e) {
          console.error("Firestore access error:", e);
        }
      } else {
        this.$router.push({ name: "clinic_list" });
      }
    },
  },
};
</script>

<style scoped>
/* 必要ならここにスタイルを追加 */
</style>
